// components/user/Paragraph.js
import React from "react";
import { useNode } from "@craftjs/core";
import {
    FormControl,
    FormLabel,
    Select,
    MenuItem,
    Grid,
    Typography,
    TextField,
    Paper,
    Box,
    Slider
} from "@material-ui/core";

export const Paragraph = ({
                              text,
                              fontSize,
                              color,
                              textAlign,
                              lineHeight,
                              margin,
                              maxWidth
                          }) => {
    const {
        connectors: { connect, drag },
        selected,
        actions: { setProp }
    } = useNode((node) => ({
        selected: node.events.selected
    }));

    return (
        <div ref={ref => connect(drag(ref))}>
            {/* Paragraph Content */}
            <div
                style={{
                    margin: `${margin}px 0`,
                    maxWidth: maxWidth === 'custom' ? `${maxWidth}px` : maxWidth
                }}
            >
                <p
                    style={{
                        fontSize: `${fontSize}px`,
                        color,
                        textAlign,
                        lineHeight,
                        margin: 0,
                        padding: 0
                    }}
                    contentEditable={selected}
                    onBlur={(e) => setProp(props => props.text = e.target.innerText)}
                    suppressContentEditableWarning={true}
                >
                    {text}
                </p>
            </div>

            {/* Settings Panel */}
            {selected && (
                <Box sx={{ mt: 2 }}>
                    <Paper>
                        <Box sx={{ p: 2 }}>
                            <Typography variant="subtitle2" gutterBottom>
                                Paragraph Settings
                            </Typography>
                            <Grid container spacing={2}>
                                {/* Text Properties */}
                                <Grid item xs={6}>
                                    <FormControl fullWidth size="small">
                                        <FormLabel>Alignment</FormLabel>
                                        <Select
                                            value={textAlign}
                                            onChange={(e) => setProp(props => props.textAlign = e.target.value)}
                                        >
                                            <MenuItem value="left">Left</MenuItem>
                                            <MenuItem value="center">Center</MenuItem>
                                            <MenuItem value="right">Right</MenuItem>
                                            <MenuItem value="justify">Justify</MenuItem>
                                        </Select>
                                    </FormControl>
                                </Grid>

                                {/* Max Width */}
                                <Grid item xs={6}>
                                    <FormControl fullWidth size="small">
                                        <FormLabel>Max Width</FormLabel>
                                        <Select
                                            value={maxWidth}
                                            onChange={(e) => setProp(props => props.maxWidth = e.target.value)}
                                        >
                                            <MenuItem value="none">Full Width</MenuItem>
                                            <MenuItem value="75ch">Readable (75ch)</MenuItem>
                                            <MenuItem value="65ch">Narrow (65ch)</MenuItem>
                                            <MenuItem value="custom">Custom</MenuItem>
                                        </Select>
                                    </FormControl>
                                </Grid>

                                {/* Font Size */}
                                <Grid item xs={12}>
                                    <FormControl fullWidth>
                                        <FormLabel>Font Size (px)</FormLabel>
                                        <Slider
                                            value={fontSize}
                                            onChange={(_, value) => setProp(props => props.fontSize = value)}
                                            min={12}
                                            max={24}
                                            step={1}
                                            marks={[
                                                { value: 12, label: '12' },
                                                { value: 16, label: '16' },
                                                { value: 24, label: '24' }
                                            ]}
                                        />
                                    </FormControl>
                                </Grid>

                                {/* Line Height */}
                                <Grid item xs={12}>
                                    <FormControl fullWidth>
                                        <FormLabel>Line Height</FormLabel>
                                        <Slider
                                            value={parseFloat(lineHeight)}
                                            onChange={(_, value) => setProp(props => props.lineHeight = value)}
                                            min={1}
                                            max={2}
                                            step={0.1}
                                            marks={[
                                                { value: 1, label: '1' },
                                                { value: 1.5, label: '1.5' },
                                                { value: 2, label: '2' }
                                            ]}
                                        />
                                    </FormControl>
                                </Grid>

                                {/* Color */}
                                <Grid item xs={6}>
                                    <FormControl fullWidth size="small">
                                        <FormLabel>Color</FormLabel>
                                        <TextField
                                            value={color}
                                            onChange={(e) => setProp(props => props.color = e.target.value)}
                                            placeholder="#000000"
                                        />
                                    </FormControl>
                                </Grid>

                                {/* Margin */}
                                <Grid item xs={6}>
                                    <FormControl fullWidth size="small">
                                        <FormLabel>Margin (px)</FormLabel>
                                        <TextField
                                            type="number"
                                            value={margin}
                                            onChange={(e) => setProp(props => props.margin = parseInt(e.target.value))}
                                            inputProps={{ min: 0 }}
                                        />
                                    </FormControl>
                                </Grid>
                            </Grid>
                        </Box>
                    </Paper>
                </Box>
            )}
        </div>
    );
};

// Default props and Craft.js configuration
Paragraph.craft = {
    props: {
        text: "Start typing your paragraph here...",
        fontSize: 16,
        color: "#000000",
        textAlign: "left",
        lineHeight: 1.6,
        margin: 16,
        maxWidth: "75ch"
    },
    related: {
        toolbar: true,
        settings: true
    }
};